/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserById = /* GraphQL */ `
  query GetUserById {
    getUserById {
      id
      administratorOf
      memberOf
      vaults {
        vault_id
        org_id
        vault_name
        invitation_accepted
        invite_mode
        first_action_completed
      }
      displayName
      email
      phone
      verified_email
      status
      favoriteVaults
      acceptedTermVaults
      mfaSetupCompleted
      mfaEnforcementDate
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getOrgById = /* GraphQL */ `
  query GetOrgById($org_id: ID!) {
    getOrgById(org_id: $org_id) {
      id
      administrator_user_id
      companyName
      tier
      stripeSubId
      stripeCustomerId
      subscriptionEndDate
      requireMfaForVaultAccess
      singleSignOnEnabled
      termsAndConditions
      termsEnforced
      passwordControlRequirements
      deviceLimitPerUser
      allowMembersToJoinOtherVaults
      enableComments
      enableFileRequests
      body
      subject
      header
      guestInvite_subject
      guestInvite_header
      guestInvite_body
      memberInvite_subject
      memberInvite_body
      taskReminder_subject
      taskReminder_intro
      taskReminder_closing
      notification_subject
      notification_body
      magicLink_subject
      magicLink_body
      magicLink_expiry
      permissions {
        user_id
        user_name
        user_email
        view_files
        upload_files
        rename_files
        delete_files
        manage_perms
        create_vault
        access_vault
        invitation_accepted
        upload_notification
        download_notification
        edit_settings
        manage_members
        _deleted
      }
      limitMemberSessionTimeoutLength
      logo_s3_path
      hideZapaLogo
      primaryBrandColor
      primaryBrandColorName
      workflowStatesEnabled
      workflowStates {
        id
        name
      }
      externalSystems
      replyToEmail
      apiEnabled
      webhooksEnabled
      aiFileNamingDisabled
      taxiIntegration {
        enabled
        key_hint
        updated_at
        updated_by
        last_error
        last_error_at
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getVaultById = /* GraphQL */ `
  query GetVaultById($vault_id: ID!, $loadAuditHistory: Boolean!) {
    getVaultById(vault_id: $vault_id,loadAuditHistory: $loadAuditHistory) {
      id
      name
      org_id
      org_name
      external_email
      initial_user_id
      last_upload_at
      last_pdf_sign_at
      last_pdf_form_at
      last_comment_at
      last_download_at
      last_action
      users
      orgTier
      permissions {
        user_name
        user_email
        user_type
        user_id
        view_files
        upload_files
        rename_files
        delete_files
        access_vault
        upload_notification
        download_notification
        invitation_accepted
        _deleted
      }
      private_mode
      hide_perms
      restricted_upload_path
      tags
      archived
      isTemplate
      workflowStateId
      workflowStateName
      workflowId
      currentWorkflowStateId
      currentWorkflowStateName
      workflow {
        id
        org_id
        name
        description
        states {
          id
          name
        }
        is_default
        created_at
      }
      orgWorkflowStates {
        id
        name
      }
      orgWorkflowStatesEnabled
      externalSystemIds
      taxi_link {
        status
        tenant_id
        customer_id
        display_name
        verified_at
        error
      }
      createdAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getVaultAuditHistoryById = /* GraphQL */ `
  query GetVaultById($vault_id: ID!, $loadAuditHistory: Boolean!) {
    getVaultById(vault_id: $vault_id, loadAuditHistory: $loadAuditHistory) {
      id
      name
      org_id
      org_name
      initial_user_id
      external_email
      last_upload_at
      last_pdf_sign_at
      last_pdf_form_at
      last_comment_at
      last_download_at
      last_action
      orgTier
      users
      permissions {
        user_name
        user_email
        user_id
        user_type
        view_files
        upload_files
        rename_files
        delete_files
        access_vault
        upload_notification
        download_notification
        invitation_accepted
        _deleted
      }
      audit_history {
        action
	    file_id
	    filename
	    description
	    description_html
	    action_date
	    user_id
	    org_id
	    username
      }
      private_mode
      restricted_upload_path
      tags
      archived
      isTemplate
      workflowStateId
      workflowStateName
      workflowId
      currentWorkflowStateId
      currentWorkflowStateName
      workflow {
        id
        org_id
        name
        description
        states {
          id
          name
        }
        is_default
        created_at
      }
      orgWorkflowStates {
        id
        name
      }
      orgWorkflowStatesEnabled
      externalSystemIds
      createdAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getVaultsByOrgId = /* GraphQL */ `
  query GetVaultsByOrgId($templatesOnly: Boolean) {
    getVaultsByOrgId(templatesOnly: $templatesOnly) {
      id
      name
      org_id
      org_name
      external_email
      initial_user_id
      last_upload_at
      last_pdf_sign_at
      last_pdf_form_at
      last_comment_at
      last_download_at
      last_action
      orgTier
      users
      permissions {
        user_name
        user_email
        user_id
        user_type
        view_files
        upload_files
        rename_files
        delete_files
        access_vault
        upload_notification
        download_notification
        invitation_accepted
        _deleted
      }
      num_tasks_closed
      num_tasks_open
      earliest_open_task_date
      private_mode
      hide_perms
      restricted_upload_path
      tags
      archived
      isTemplate
      workflowStateId
      workflowStateName
      workflowId
      currentWorkflowStateId
      currentWorkflowStateName
      workflow {
        id
        org_id
        name
        description
        states {
          id
          name
        }
        is_default
        created_at
      }
      orgWorkflowStates {
        id
        name
      }
      orgWorkflowStatesEnabled
      externalSystemIds
      createdAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
// Paginated version for large orgs - use this on the dashboard to avoid AppSync's
// 1MB response limit. Loop until nextToken is null to gather the full list.
export const getVaultsByOrgIdPaginated = /* GraphQL */ `
  query GetVaultsByOrgIdPaginated($templatesOnly: Boolean, $limit: Int, $nextToken: String) {
    getVaultsByOrgIdPaginated(templatesOnly: $templatesOnly, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        org_id
        org_name
        external_email
        initial_user_id
        last_upload_at
        last_pdf_sign_at
        last_pdf_form_at
        last_comment_at
        last_download_at
        last_action
        orgTier
        users
        permissions {
          user_name
          user_email
          user_id
          user_type
          view_files
          upload_files
          rename_files
          delete_files
          access_vault
          upload_notification
          download_notification
          invitation_accepted
          _deleted
        }
        num_tasks_closed
        num_tasks_open
        earliest_open_task_date
        private_mode
        hide_perms
        restricted_upload_path
        tags
        archived
        isTemplate
        workflowStateId
        workflowStateName
        orgWorkflowStates {
          id
          name
        }
        orgWorkflowStatesEnabled
        createdAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
  }
`;
export const getMembersForOrgId = /* GraphQL */ `
  query GetMembersForOrgId($org_id: ID!) {
    getMembersForOrgId(org_id: $org_id) {
      id
      administratorOf
      memberOf
      vaults {
        vault_id
	    org_id
	    vault_name
	    invitation_accepted
      }
      displayName
      email
      phone
      verified_email
      status
      favoriteVaults
	  acceptedTermVaults
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getFilesByVaultId = /* GraphQL */ `
  query GetFilesByVaultId($vault_id: ID!, $show_deleted: Boolean) {
    getFilesByVaultId(vault_id: $vault_id, show_deleted: $show_deleted) {
      id
      vault_id
      parent_folder_file_id
      org_id
      extension
      size
      name
      created_date
      created_by
      created_by_name
      modified_on
      modified_by
      modified_by_name
      modified_by_email
      downloaded_by
      downloaded_by_host
      uploaded_by_host
      signature_status
      signatures_outstanding
      signature_progress
      comments {
        comment
        user_name
        created_date
        created_by
        _lastChangedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
// Paginated version for large vaults - use this to avoid "Transformation too large" errors
export const getFilesByVaultIdPaginated = /* GraphQL */ `
  query GetFilesByVaultIdPaginated($vault_id: ID!, $show_deleted: Boolean, $limit: Int, $nextToken: String) {
    getFilesByVaultIdPaginated(vault_id: $vault_id, show_deleted: $show_deleted, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vault_id
        parent_folder_file_id
        org_id
        extension
        size
        name
        created_date
        created_by
        created_by_name
        modified_on
        modified_by
        modified_by_name
        modified_by_email
        downloaded_by
        downloaded_by_host
        uploaded_by_host
        signature_status
        signatures_outstanding
        signature_progress
        comments {
          comment
          user_name
          created_date
          created_by
          _lastChangedAt
        }
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
    }
  }
`;
export const getTasksByVaultId = /* GraphQL */ `
  query getTasksByVaultId(
    $vault_id: ID
  ) {
    getTasksByVaultId(vault_id: $vault_id) {
      id
      vault_id
      org_id
      created_by
      created_by_name
      attached_files
      clientResponse
      action_type
      title
      description
      status
      due_date
      send_reminder
      completed_date
      completed_by
      completed_by_name
      comments {
        id
        comment
        created_date
        created_by
        user_name
        _version
        _deleted
        _lastChangedAt
      }
      assigned_guests {
        id
        name
        org_id
      }
      assigned_members {
        id
        name
        org_id
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getVaultToken = /* GraphQL */ `
  query getVaultToken($org_id: ID!, $vault_id: ID!, $token: String) {
    getVaultToken(org_id: $org_id, vault_id: $vault_id, token: $token)
  }
`;
export const getSignedFileUrl = /* GraphQL */ `
  query GetSignedFileUrl($org_id: ID!, $vault_id: ID!, $file_id: String!, $filename: String, $extension: String, $inline: Boolean) {
    getSignedFileUrl(org_id: $org_id, vault_id: $vault_id, file_id: $file_id, filename: $filename, extension: $extension, inline: $inline)
  }
`;
export const getSignedThumbnailUrl = /* GraphQL */ `
  query GetSignedThumbnailUrl($thumbnail_path: String!) {
    getSignedThumbnailUrl(thumbnail_path: $thumbnail_path)
  }
`;
export const getStripe = /* GraphQL */ `
  query GetStripe($stripeCustomerId: String!, $stripeEdit : Boolean) {
    getStripe(stripeCustomerId : $stripeCustomerId, stripeEdit : $stripeEdit)
  }
`;
export const getBillingRedirectUrl = /* GraphQL */ `
  query GetBillingRedirectUrl($stripeCustomerId: String!) {
    getBillingRedirectUrl(stripeCustomerId : $stripeCustomerId)
  }
`;

export const getActiveVaultUsers = /* GraphQL */ `
  query GetActiveVaultUsers($vault_id: ID!) {
    getActiveVaultUsers(vault_id: $vault_id) {
      vault_id
      session_id
      user_id
      user_name
      user_email
      status
      last_heartbeat
      joined_at
    }
  }
`;

export const getActiveOrgUsers = /* GraphQL */ `
  query GetActiveOrgUsers($org_id: ID!) {
    getActiveOrgUsers(org_id: $org_id) {
      vault_id
      session_id
      org_id
      vault_name
      user_id
      user_name
      user_email
      status
      last_heartbeat
      joined_at
    }
  }
`;

export const getWebRTCSignal = /* GraphQL */ `
  query GetWebRTCSignal($signal_id: String!) {
    getWebRTCSignal(signal_id: $signal_id) {
      id
      vault_id
      from_user_id
      to_user_id
      signal_type
      signal_data
      created_at
      ttl
    }
  }
`;

export const getSignatureRequest = /* GraphQL */ `
  query GetSignatureRequest(
    $signature_request_id: ID!
    $token: String!
  ) {
    getSignatureRequest(
      signature_request_id: $signature_request_id
      token: $token
    ) {
      id
      portal_id
      file_id
      file_name
      file_deleted
      sender_user_id
      recipient_email
      current_recipient_email
      recipients {
        email
        name
        order
        status
        assigned_fields
        completed_at
        color
        token
        is_any_guest
      }
      field_assignments
      required_fields_xfdf
      custom_message
      status
      created_at
      completed_at
      expires_at
    }
  }
`;

export const getSignatureRequestsByOrgId = /* GraphQL */ `
  query GetSignatureRequestsByOrgId($org_id: ID!) {
    getSignatureRequestsByOrgId(org_id: $org_id) {
      id
      portal_id
      file_id
      file_name
      file_deleted
      sender_user_id
      sender_name
      sender_email
      org_id
      org_name
      org_logo
      recipients {
        email
        name
        order
        status
        assigned_fields
        completed_at
        color
        token
        is_any_guest
      }
      recipient_email
      field_assignments
      required_fields_xfdf
      custom_message
      status
      token
      created_at
      completed_at
      expires_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const getSignatureRequestsByPortalId = /* GraphQL */ `
  query GetSignatureRequestsByPortalId($portal_id: ID!) {
    getSignatureRequestsByPortalId(portal_id: $portal_id) {
      id
      portal_id
      file_id
      file_name
      file_deleted
      sender_user_id
      sender_name
      sender_email
      org_id
      org_name
      org_logo
      recipients {
        email
        name
        order
        status
        assigned_fields
        completed_at
        color
        token
        is_any_guest
      }
      recipient_email
      field_assignments
      required_fields_xfdf
      custom_message
      status
      token
      created_at
      completed_at
      expires_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const checkSubdomainAvailability = /* GraphQL */ `
  query CheckSubdomainAvailability($subdomain: String!) {
    checkSubdomainAvailability(subdomain: $subdomain)
  }
`;

export const getOrgBySubdomain = /* GraphQL */ `
  query GetOrgBySubdomain($subdomain: String!) {
    getOrgBySubdomain(subdomain: $subdomain) {
      id
      subdomain
      logo_s3_path
      primaryBrandColor
      hideZapaLogo
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const getPublicOrgById = /* GraphQL */ `
  query GetPublicOrgById($org_id: ID!) {
    getPublicOrgById(org_id: $org_id) {
      id
      subdomain
      logo_s3_path
      primaryBrandColor
      hideZapaLogo
      isDemoOrg
      demoVideoUrl
      demoBookingUrl
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const checkMfaRequirement = /* GraphQL */ `
  query CheckMfaRequirement {
    checkMfaRequirement {
      mfaRequired
      mfaEnforcementDate
      mfaSetupCompleted
    }
  }
`;

export const getMfaQrCode = /* GraphQL */ `
  query GetMfaQrCode($accessToken: String!) {
    getMfaQrCode(accessToken: $accessToken) {
      success
      message
      qrCodeDataUrl
      secretCode
      session
    }
  }
`;

export const getWorkflowsByOrgId = /* GraphQL */ `
  query GetWorkflowsByOrgId($org_id: ID!) {
    getWorkflowsByOrgId(org_id: $org_id) {
      id
      org_id
      name
      description
      states {
        id
        name
      }
      is_default
      created_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const getOAuthClients = /* GraphQL */ `
  query GetOAuthClients {
    getOAuthClients {
      client_id
      org_id
      name
      redirect_uris
      allowed_scopes
      created_at
      created_by
    }
  }
`;

export const getWebhooks = /* GraphQL */ `
  query GetWebhooks {
    getWebhooks {
      org_id
      webhook_id
      url
      events
      secret
      enabled
      created_at
      created_by
      last_triggered_at
    }
  }
`;

export const getWebhookDeliveries = /* GraphQL */ `
  query GetWebhookDeliveries($webhook_id: ID!, $limit: Int) {
    getWebhookDeliveries(webhook_id: $webhook_id, limit: $limit) {
      delivery_id
      webhook_id
      event_type
      payload
      status
      http_status_code
      error_message
      attempt_count
      created_at
      delivered_at
    }
  }
`;

export const getTaxiDeliveries = /* GraphQL */ `
  query GetTaxiDeliveries($org_id: ID!, $vault_id: ID!) {
    getTaxiDeliveries(org_id: $org_id, vault_id: $vault_id) {
      id
      event
      file_id
      file_name
      task_id
      status
      attempts
      next_attempt_at
      last_error
      remote_key
      created_at
      updated_at
      delivered_at
    }
  }
`;

export const getWorkflow = /* GraphQL */ `
  query GetWorkflow($id: ID!) {
    getWorkflow(id: $id) {
      id
      org_id
      name
      description
      states {
        id
        name
      }
      is_default
      created_at
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const getVaultByExternalId = /* GraphQL */ `
  query GetVaultByExternalId($org_id: ID!, $external_system: String!, $external_id: String!) {
    getVaultByExternalId(org_id: $org_id, external_system: $external_system, external_id: $external_id) {
      id
      name
      org_id
      org_name
      externalSystemIds
      _version
      _deleted
      _lastChangedAt
    }
  }
`;

export const searchVaults = /* GraphQL */ `
  query SearchVaults($org_id: ID!, $search_term: String!, $limit: Int) {
    searchVaults(org_id: $org_id, search_term: $search_term, limit: $limit) {
      id
      name
      org_id
      org_name
      tags
      externalSystemIds
      archived
      isTemplate
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
